import { Form, Checkbox, Typography, Select } from "antd";
import React from "react";
import ModalWithButton from "@src/components/Common/ModalWithButton";

const { Text } = Typography;


const PackForm = (form: any, disabled: boolean) => {
    return (
        <div style={{ paddingLeft: '0px' }}>
            <Form.Item name={["extra_data", "include_change_instance"]} valuePropName="checked" style={{ marginBottom: '8px' }}>
                <Checkbox disabled={disabled}>
                    Include change instance (last change instance related to service item in payload)
                </Checkbox>
            </Form.Item>
            <Form.Item name={["extra_data", "enable_pack_context"]} valuePropName="checked" style={{ marginBottom: '8px' }}>
                <Checkbox disabled={disabled}>
                    Enable pack context (vector document to be sent in payload)
                </Checkbox>
            </Form.Item>
            <Form.Item name={["extra_data", "include_previous_declaration"]} valuePropName="checked" style={{ marginBottom: '8px' }}>
                <Checkbox disabled={disabled}>
                    Include previous declaration (previous declaration for service item in payload)
                </Checkbox>
            </Form.Item>
            <Form.Item name={["extra_data", "include_service_config"]} valuePropName="checked" style={{ marginBottom: '8px' }}>
                <Checkbox disabled={disabled}>
                    Include service config (latest service config JSON in payload)
                </Checkbox>
            </Form.Item>
            <Form.Item
                name={["extra_data", "include_previous_pipeline_data"]}
                label={<Text>Include last pipeline's stages when retriggering</Text>}
                style={{ marginBottom: '8px' }}
                labelCol={{span: 7}}
            >
                {disabled ? (
                    <Text style={{ display: 'block', padding: '4px 0', fontSize: '14px' }}>
                        {form.getFieldValue(["extra_data", "include_previous_pipeline_data"])?.join(', ') || 'no stage'}
                    </Text>
                ) : (
                    <Select
                        mode="multiple"
                        placeholder="Select Action Types"
                        style={{ width: '280px' }}
                    >
                        <Select.Option value="config">Config</Select.Option>
                        <Select.Option value="verify">Verify</Select.Option>
                        <Select.Option value="execution">Execution</Select.Option>
                    </Select>
                )}
            </Form.Item>
            <Form.Item name={["extra_data", "enable_generative_ui"]} valuePropName="checked" style={{ marginBottom: '8px' }}>
                <Checkbox disabled={disabled}>
                    Enable generative UI (AI responds with rich UI components)
                </Checkbox>
            </Form.Item>
            <Form.Item name={["extra_data", "generative_ui_schema"]} hidden><input /></Form.Item>
            <Form.Item noStyle shouldUpdate={(prev, cur) =>
                prev?.extra_data?.enable_generative_ui !== cur?.extra_data?.enable_generative_ui ||
                prev?.extra_data?.generative_ui_schema !== cur?.extra_data?.generative_ui_schema
            }>
                {({ getFieldValue }) => getFieldValue(["extra_data", "enable_generative_ui"]) && (
                    <Form.Item labelCol={{span: 7}}  label={<Text>Generative UI Schema :</Text>} colon={false} style={{ marginBottom: '8px' }}>
                        {/*<div style={{ width: '280px' }}>*/}
                        <ModalWithButton
                            handleOk={disabled ? () => {} : (value: any) => {
                                if (value != null) {
                                    const serialized = typeof value === 'string' ? value : JSON.stringify(value, null, 2);
                                    form.setFieldsValue({ extra_data: { ...form.getFieldValue("extra_data"), generative_ui_schema: serialized } });
                                } else {
                                    form.setFieldsValue({ extra_data: { ...form.getFieldValue("extra_data"), generative_ui_schema: null } });
                                }
                            }}
                            editorType={"json"}
                            buttonTitle={disabled ? "View Generative UI Schema" : "Edit/View Generative UI Schema"}
                            initialValue={form.getFieldValue(["extra_data", "generative_ui_schema"]) || ""}
                        />
                        {/*</div>*/}
                    </Form.Item>
                )}
            </Form.Item>
        </div>
    );
}

export default PackForm;
